import componentsDictionary from "./componentsDictionary.js"

/**
 * This function will transform received schema into consumable schema for form components
 * It sources components from dictionary or as a plain component object
 * It computes model field from bindTo
 */
export const computeSchema = schema => {
	return schema.map(item => {
		const { name, props } = componentsDictionary(item.component)
		return {
			...item,

			// merge props from schema with props from componentDictionary
			props: { ...props, ...item.props },

			// if we got name fomr componentsDictionary, use it, otherwise use componentObject which is a component as an object
			component: name ? name : item.componentObject,

			// last part of bindTo
			model: item?.bindTo?.split(".")?.slice(-1)?.[0] || ""
		}
	})
}
